import { useEffect, useState } from 'react'

export default function useBlobURL({ url }) {
	const [isUrlBlob, setUrlBlob] = useState(false)
	const [isLoadBlob, setLoadBlob] = useState(false)

	useEffect(() => {
		if (!url) return
		setLoadBlob(true)
		fetch(url)
			.then(re => re.blob())
			.then(blob => URL.createObjectURL(blob))
			.then(url => setUrlBlob(url))
			.catch(err => new Error(`No se pudo convertir URL: ${err}`))
			.finally(() => setLoadBlob(false))
	}, [url])

	return {
		isUrlBlob,
		isLoadBlob
	}
}
